export function guid() {
  const str = Date.now() + '' + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  return str
}

export function timestamp2Date(timestamp) {
  var date = new Date(timestamp * 1000);
  var year = date.getUTCFullYear();
  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var day = date.getDate().toString().padStart(2, '0');
  var hours = date.getHours().toString().padStart(2, '0');
  var minutes = date.getMinutes().toString().padStart(2, '0');
  var seconds = date.getSeconds().toString().padStart(2, '0');
  var formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  return formattedDate
}

//1、知道要删除项的下标值
//index为删除项的下标值  arr为源数组
export function arrRemoveIndex(index, arr) {
  if (!arr || arr.length == 0) {
    return ""
  }
  arr.splice(index, 1)
  return arr
}

//2、知道要删除项的值
//it 为要删除项的值  arr为源数组
export function arrRemove(it, arr) {
  if (!arr || arr.length == 0) {
    return ""
  }
  let flag = arr.indexOf(it)
  if (flag > -1) {
    arr.splice(flag, 1)
    return arr
  } else {
    console.log("未查找到该元素")
  }
}

//3、如果要删除项为对象，我们需要知道该对象属性中的唯一值（不会重复的值）
//arr是源数组，attr是目标数组中的属性名称，value是要删除的属性名称对应的值
export function arrRemoveObj(arr, attr, value) {
  if (!arr || arr.length == 0) {
    return ""
  }
  let newArr = arr.filter(function (item, index) {
    return item[attr] != value
  })
  return newArr
}

export function arrContainsObject(array, object) {
  return array.some(item => {
    return Object.keys(object).every(key => item[key] === object[key]);
  });
}

export function generateScripts(sqlList) {
  var scripts = ''
  for (var i = 0; i < sqlList.length; i++) {
    scripts += sqlList[i].sql + '\n\n'
  }
  return scripts
}